import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { SummaryActions } from './summary.actions';
import { ISummaryState } from './summary.state';

export const initialSummaryState: ISummaryState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const summaryReducerFn = createReducer(
  initialSummaryState,
  on(SummaryActions.reset, (state: ISummaryState, action) => {
    return new StateBuilder<ISummaryState>(initialSummaryState).build();
  }),
  on(SummaryActions.load, (state: ISummaryState, action) => {
    return new StateBuilder<ISummaryState>(state).toLoading().build();
  }),
  on(SummaryActions.loadSuccess, (state: ISummaryState, action) => {
    return new StateBuilder<ISummaryState>(state, action).toLoaded().build();
  }),
  on(SummaryActions.submit, (state: ISummaryState, action) => {
    return new StateBuilder<ISummaryState>(state, action).toLoading().build();
  }),
  on(SummaryActions.submitSuccess, (state: ISummaryState, action) => {
    return new StateBuilder<ISummaryState>(state, action).toLoaded().build();
  })
);

export function summaryReducer(state: ISummaryState | undefined, action: Action) {
  return summaryReducerFn(state, action);
}
